import type { AuthStatus } from '@/domain/types';
import type { StartTransactionDomain, StartTransactionResponse } from '@/protocol/OcppAdapter';

export function buildStartTransactionRequest(req: StartTransactionDomain): Record<string, unknown> {
  const wire: Record<string, unknown> = {
    connectorId: req.connectorId,
    idTag: req.idTag,
    meterStart: req.meterStart,
    timestamp: req.timestamp,
  };
  if (req.reservationId !== undefined) wire['reservationId'] = req.reservationId;
  return wire;
}

export function parseStartTransactionResponse(
  payload: Record<string, unknown>,
): StartTransactionResponse {
  const info = (payload['idTagInfo'] ?? {}) as Record<string, unknown>;
  return {
    transactionId: payload['transactionId'] as number,
    idTagInfo: {
      status: info['status'] as AuthStatus,
      ...(typeof info['expiryDate'] === 'string' ? { expiryDate: info['expiryDate'] } : {}),
      ...(typeof info['parentIdTag'] === 'string' ? { parentIdTag: info['parentIdTag'] } : {}),
    },
  };
}
